import Fizzy__HotkeyController from "./fizzy/hotkey_controller"

// Connects to data-controller="hotkey"
export default class extends Fizzy__HotkeyController {
  _shouldIgnore(event) {
    if (event.ctrlKey) { // hotkey with modifier allowed in input elements
      return false
    } else {
      return super._shouldIgnore(event)
    }
  }
}
